import { render } from "./ChurchSetUp.vue?vue&type=template&id=07136402&scoped=true"
import script from "./ChurchSetUp.vue?vue&type=script&lang=js"
export * from "./ChurchSetUp.vue?vue&type=script&lang=js"

import "./ChurchSetUp.vue?vue&type=style&index=0&id=07136402&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07136402"]])

export default __exports__